import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col items-center" };
const _hoisted_2 = { class: "text-xl font-bold" };
import SvgIcon from '@/components/SvgIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Loading',
    props: {
        loadingText: null
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("h1", _hoisted_2, _toDisplayString(__props.loadingText), 1),
                _createVNode(SvgIcon, {
                    name: "ellipsis",
                    class: "w-24 h-12"
                })
            ]));
        };
    }
});
